/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxfrag */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

import { N0, N40A, N50A } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export type AppLogoProps = {
	src: string;
	tblzSwitcherRoleBasedExperimentCohort?: string;
};

const imageStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		maxHeight: '24px',
		maxWidth: '26px',
		flexShrink: 0,
		lineHeight: 1,
		margin: 'auto',
	},
});

const appLogoStyles = css({
	height: '32px',
	width: '32px',
	boxSizing: 'border-box',
	backgroundColor: token('color.background.neutral', N0),
	borderRadius: '8px',
	display: 'flex',
	overflow: 'hidden',
	boxShadow: token('elevation.shadow.raised', `0 1px 1px ${N50A}, 0 0 1px 1px ${N40A}`),
});

const tblzSwitcherExperimentIconStyles = css({
	border: `1px solid ${token('elevation.shadow.overflow.spread', '#091E4224')}`,
	boxShadow: 'none',
	backgroundColor: 'transparent',
});

export const AppLogo: React.FC<AppLogoProps> = ({ src, tblzSwitcherRoleBasedExperimentCohort }) => (
	<span
		css={[
			appLogoStyles,
			tblzSwitcherRoleBasedExperimentCohort === 'experiment'
				? tblzSwitcherExperimentIconStyles
				: null,
		]}
	>
		<img css={imageStyles} src={src} />
	</span>
);

AppLogo.propTypes = {
	src: PropTypes.string.isRequired,
};
